import * as moment from "moment";
import 'moment/locale/fr';
import { ObjectService } from "../utils";
import fr from './ias.fr';
import en from './ias.en';
let Translations = {};
let isDirty = true;
class LocaleFactory {
    constructor() {
        this.trans = (key, params) => {
            if (isDirty) {
                if (!this._initializeLocales()) {
                    return ' ';
                }
            }
            params = params || [];
            let msg = this.Trans[key] ? this.Trans[key] : key;
            if (!this.Trans[key] && this._logger) {
                this._logger.warning('[TRANSLATION] missing translation key: ' + key);
            }
            for (const k in params) {
                if (!params.hasOwnProperty(k)) {
                    continue;
                }
                if (typeof params[k] == "string" || typeof params[k] == "number") {
                    msg = msg.replace(`__${k}__`, params[k]);
                }
            }
            if (params.hasOwnProperty('count')) {
                if (msg.indexOf('|') !== -1) {
                    const parts = msg.split('|');
                    if (parts.length === 2 && params.hasOwnProperty('count')) {
                        msg = params.count > 1 ? parts[1] : parts[0];
                    }
                    else if (parts.length === 3 && params.hasOwnProperty('count')) {
                        msg = params.count === 0 ? parts[0] : (params.count > 1 ? parts[2] : parts[1]);
                    }
                }
            }
            return msg;
        };
        this.getModule = (name) => {
            if (this.hasOwnProperty(name)) {
                return this[name];
            }
            return null;
        };
        this.getLocale = () => this.locale;
        this.getAntdLocale = () => this.AntDesignTrans;
        this.setLocale = (locale) => {
            this.locale = locale;
            isDirty = true;
        };
        this.initMoment = () => {
            moment.locale(this.locale);
        };
        this.addTranslation = (trans) => {
            Translations = ObjectService.mergeDeep(Translations, trans);
            isDirty = true;
        };
        this.locale = this._getNavigatorLocale();
        this.initMoment();
    }
    _getNavigatorLocale() {
        const navLanguage = navigator.language || navigator.browserLanguage || 'fr';
        return navLanguage.split('-')[0];
    }
    _initializeLocales() {
        const translations = Translations[this.locale] || Translations.fr;
        if (!translations) {
            return false;
        }
        this.Table = translations.Table;
        this.Modal = translations.Modal;
        this.Popconfirm = translations.Popconfirm;
        this.Transfer = translations.Transfert;
        this.Select = translations.Select;
        this.Pagination = translations.Pagination;
        this.TimePicker = translations.TimePicker;
        this.ImagePicker = translations.ImagePicker;
        this.DatePicker = {
            lang: translations.DatePicker.lang,
            timePickerLocale: this.TimePicker,
        };
        this.Calendar = this.DatePicker;
        this.Trans = this._compileTranslations(translations.Trans);
        this.AntDesignTrans = translations.AntDesign;
        isDirty = false;
        return true;
    }
    _compileTranslations(translationsToCompile, prefix) {
        const compiledTrans = [];
        prefix = prefix || '';
        for (const k in translationsToCompile) {
            if (translationsToCompile.hasOwnProperty(k)) {
                if (typeof translationsToCompile[k] === "string" && k === "_") {
                    compiledTrans[prefix.slice(0, -1)] = translationsToCompile[k];
                }
                else if (typeof translationsToCompile[k] === 'string') {
                    compiledTrans[prefix + k] = translationsToCompile[k];
                }
                else {
                    const children = this._compileTranslations(translationsToCompile[k], `${prefix + k}.`);
                    Object.assign(compiledTrans, children);
                }
            }
            else {
            }
        }
        return compiledTrans;
    }
    setLogger(logger) {
        this._logger = logger;
    }
}
const Locale = new LocaleFactory();
Locale.addTranslation({
    fr,
    en,
});
export { Locale };
//# sourceMappingURL=Locale.js.map